export const AuthApiEndpoints = {
  GET_TOKEN: `/users/token`
};
